import Vue from 'vue'
import Router from 'vue-router'
import routerLists from './routerLists';
import vote from '@/components/pages/vote'
import privacy from '@/components/pages/privacy/privacy'
import terms from '@/components/pages/privacy/terms'

Vue.use(Router)
/** 避免重复点击报错 */
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
export default new Router({
  mode: 'history',
  routes: [...routerLists, {
    path: '/vote',
    label: '金翎奖投票',
    key: 'vote',
    component: vote
  },
  {
    path: '/privacy',
    label: 'Privacy',
    key: 'privacy',
    component: privacy
  },
  {
    path: '/terms',
    label: 'Terms',
    key: 'terms',
    component: terms
  }]
})



// WEBPACK FOOTER //
// ./src/router/index.js